<script setup lang="ts">
  defineProps<{ blok: any }>()

  const { isDesktopLarge, isDesktopSmall, isTablet } = useBTBreakpoints()

  const imageWidth = computed(() => {
    if (isDesktopLarge.value) {
      return 1872
    }

    if (isDesktopSmall.value) {
      return 1200
    }

    if (isTablet.value) {
      return 728
    }

    return 576
  })

  const imageHeight = computed(() => {
    if (isDesktopLarge.value) {
      return 1076
    }

    if (isDesktopSmall.value) {
      return 676
    }

    if (isTablet.value) {
      return 810
    }

    return 336
  })
</script>
<template>
  <div class="aspect-video w-full overflow-hidden md:mx-auto">
    <NuxtImg
      v-if="blok.image.filename"
      provider="storyblok"
      class="h-full w-full rounded-sm object-cover"
      :title="blok.image.title"
      :src="blok.image.filename"
      :alt="blok.image.alt"
      :width="imageWidth"
      :height="imageHeight"
      :modifiers="{ filters: { focal: blok.image?.focus }, smart: true }"
      loading="lazy"
    />
  </div>
</template>
